import util from '../util'

let controller = 'ParticipanteSPIParceiroLiberacao'
export default {
  ListarPorParticipante: function (ispb) {
    return util.Axios.Get(controller, ispb)
  },
  Inserir: function (dto) {
    return util.Axios.Post(controller, dto)
  },
  AlterarStatus: function (codigo, ativo) {
    return util.Axios.Put(controller, `${codigo}/Status`, { ativo: ativo })
  }
}
